import React from 'react';
import { AGOWorkshop } from '../components/LearnEarn/AGOWorkshop';
import useSEO from '../utils/useSEO';

const WorkshopPage = () => {
  useSEO({
    title: 'Workshop for Students | Skill Development & Earning Programs | AGO Innovations',
    description:
      'AGO Innovations workshops help students develop real-world skills — web development, content writing, finance basics, and more. Join a workshop and start earning while learning.',
    keywords:
      'workshop for students India, student workshop, skill development workshop, web development workshop, earn while studying, student training programs',
    canonical: 'https://agoinnovations.in/learn/workshop',
  });

  return <AGOWorkshop />;
};

export default WorkshopPage;